import { useEffect } from 'react';
import { useFeatureToggles } from '../../../feature-toggles';
import { useQuery } from '../../../hooks/use-query';
import { catalogCorrectionsToggle } from './catalog-corrections';

export const personAndContactDetailsSection = 'person-og-kontaktoplysninger';
export const addressHistorySection = 'adresser';

// The omnibar scrolls to a section by id; a collapsed section would hide what the user asked for.
export function useExpandOmnibarSection(sectionId: string, isExpanded: boolean, expand: () => void) {
  const isEnabled = useFeatureToggles().isFeatureEnabled(catalogCorrectionsToggle);
  const omnibarLink = useQuery('omnibar-link');

  useEffect(() => {
    if (isEnabled && omnibarLink === sectionId && !isExpanded) expand();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEnabled, omnibarLink]);
}
